import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { memo, useMemo } from 'react';
import RoundedRectWithBorder from '../RoundedRectWithBorder';
const PlaceholderEntity = ({ scale, fillRgba, depthWrite = false, children = null, renderOrder, onPointerDown, onPointerUp, ...props }) => {
    const userData = useMemo(() => ({ renderOrder, contentId: 'Placeholder' }), [renderOrder]);
    return (_jsxs("group", { ...props, userData: userData, children: [_jsx(RoundedRectWithBorder, { renderOrder: renderOrder, scale: scale, rotation: [0, 0, 0], position: [0, 0, 0], opacity: 1, fillRgba: fillRgba, depthWrite: depthWrite, onPointerUp: onPointerUp || undefined, onPointerDown: onPointerDown || undefined }), children] }));
};
export default memo(PlaceholderEntity);
